<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span @click="GoreportOutside">武装自己></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>【纪检监察群英谱】刘刚：不忘初心守忠诚</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>中等个子，戴着一副眼镜，眼神中透露出刚毅和耿直。这是刘刚给人的第一印象。</h3>
        <h3>“这小伙子不错！案子不破誓不罢休，九头牛都拉不回来！”熟悉的人说到他都赞不绝口。</h3>
        <h3>“有党纪党规撑腰，我就有从严执纪的底气和硬气！”这是他常挂在嘴边的一句话。</h3>
        <h3>2016年5月，襄阳市纪委指定办案，他与领导干部李某“正面交锋”。</h3>
        <h3>李某在襄州区多个乡镇当过镇长、党委书记，又任襄州区城乡建设局党委书记、局长长达9年之久，为人圆滑世故、人际关系盘根错节，自恃资格老、贡献大，根本不把长相憨厚、看似木讷的“后生”放在眼中，态度十分傲慢。</h3>
        <h3>“你不把我放在眼里无所谓，但决不能漠视党纪党规!”刘刚字字千钧，一语中的。</h3>
        <h3>面对刘刚720个小时的“全程陪护”和连续10天的政策攻心和纪律教育，李某终于全线崩溃，主动认错交代了问题。</h3>
        <h3>最终查实李某与他人合伙经商，涉及违纪资金190万元，受贿39万元，并将其移送司法机关。这一块“硬骨头”被啃了下来。</h3>
        <h3>“那么较真干什么？你又得不到啥好处！” “纪律底线是绝对不能碰的！群众利益是绝对要捍卫的！要查就要一查到底！”面对一些亲朋好友的“劝说”，他却掷地有声。</h3>
        
        <div class="PIC-BOX">
          <img :src="PicBannertest1" alt />
        </div>
        <h3>“执纪为民”是他信奉的座右铭。2015年底，时任襄城区第一纪检监察室主任的他负责调查卧龙镇闻畈村原村委会委员、报账员张某在项目落户征地过程中挪用公款的线索。由于距离案发时间较长，要从繁琐的财务账册和财务数据中找到证据，如同大海捞针，核查起来难度不小。</h3>
        <h3>执纪审查重事实、讲证据，作为此案的主办人，他决定从该村90户村民入手，逐户核实村民实际领取征地补偿资金的具体金额和情况。</h3>
        <h3>寒冬腊月，刚下过雪的地面泥泞不堪，刘刚深一脚浅一脚地走进农户家核查取证。尽管凛冽的寒风把他的双颊吹红了、手冻伤了，他依然坚持挨家挨户走访、不漏掉一个线索和证据。</h3>
        <h3>一直到深夜，再赶回办公室核查村里的账目，查找蛛丝马迹。</h3>
        <h3>多少个寒冷的夜晚，就这样在办公室度过。整整半个月，白天就到村里调查取证，夜晚就在单位加班审核账目。</h3>
        <h3>功夫不负有心人。终于发现张某瞒天过海、移花接木把公款存入私人账户的违纪事实，最终查实其挪用公款13万多元的违纪违法问题，毅然铲除了危害群众利益的“蝇贪”。</h3>
        <h3>刘刚始终践行一名优秀纪检干部应有的信仰和品格，耐住了寂寞、守住了清贫、经住了考验，在执纪审查的岗位上，他先后主办和参与查办了128件案件，其中大要案26件，移送司法机关36人。2017年11月，他被授予“全省优秀纪检监察干部”荣誉称号。（通讯员余玮）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/wzzj1-1.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside(){
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
   padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}

img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>